import { CouponRegistration } from './coupon-registration';
import { PromoReturn } from './promo-return';

export class AuthenticationReturn {
  constructor(public Registration: CouponRegistration, public Code: string, public PromoActive: PromoReturn[], public Token: string) { }
}
